import { render, staticRenderFns } from "./idtouch.vue?vue&type=template&id=0a562e2c&"
import script from "./idtouch.vue?vue&type=script&lang=js&"
export * from "./idtouch.vue?vue&type=script&lang=js&"
import style0 from "./idtouch.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports